import { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';

import PaiGowGameBoard from './UI/PaiGowGameBoard';
import user_img from "../../../../../assets/games/PaiGow/profile_img.png"
import balance_img from "../../../../../assets/games/PaiGow/balance_img.png"
import betChip_img from "../../../../../assets/games/PaiGow/betChip_img.png"
import winCup_img from "../../../../../assets/games/PaiGow/winCup_img.png"
import SoundImg from "../../../../../assets/games/PaiGow/SoundImg.png"
import muteImg from "../../../../../assets/games/PaiGow/muteImg.png"
import infoImg from "../../../../../assets/games/PaiGow/infoImg.png"

import './UI/newPaiGow.scss'
import { FaBars } from "react-icons/fa";
import PaiGowGameControllers from './UI/PaiGowGameControllers';
import OptionsMenu from '../../../../../library/OptionsMenu/OptionsMenu';
import CoinBurst from '../../CoinBurst';
import WinAnimation from '../../../Utillitys/WinAnimaion';
import CardSparkAnimation from '../../../../../library/NewCardWinAnimation/CardSparkAnimation';
// 1. Wrap the component in React.forwardRef

const GameRules = [
    { "name": `Pai Gow Poker is played with a deck of 53 cards: a standard deck plus one wild Joker. Each player is dealt 7 cards and must split them into two hands.` },
    { "name": `The first hand is referred to as "the highest hand", and consists of 5 cards. The second hand is referred to as "the second highest", and consists of only 2 cards.` },
    {
        "name": ` The game follows general poker ranking rules: one pair, three of a kind, etc. The 5-card hand must always rank higher than the 2-card hand. For example, if your seven cards are: Ace + Ace +9+7+5 + 4 + 3, you cannot place the two Aces as in your 2-card hand. The pair of Aces must be kept in "the highest hand" (i.е. the 5-card hand). 
Your goal as the player is to beat both of the dealer's hands; the highest and the second highest. If you only succeed in winning one of the two hands, the round results in a tie, or "push".` },


    { "name": `If both your hands lose against the dealer's hands, the dealer takes the bet. If both of your hands beat the dealer's hands, you receive "even money" on your bet (i.e. 1 to 1), with the exception that the bank takes a 5% commission from your winnings.` },
    { "name": `Pai Gow Poker games follow the standard rules. The exceptions, however, are that players cannot play the dragon or act as dealer.` },
    { "name": `Furthermore, the players do not lose their bets if they mistakenly create a "dead hand", but are merely warned to rearrange their cards.` },
    { "name": `When you play in a traditional, real-life casino, it is very important to keep "the dead hand" in mind. ` },
    { "name": `A dead hand results when the Pai Gow player fails to divide the seven cards properly into a highest and second highest hand. ` },
    { "name": `If the player places his two best cards in the second highest hand, the player's hand is considered "dead" and he loses instantly. ` },
    { "name": `This will not happen to Pai Gow players at this Casino. When you make a mistake dividing your seven cards, you are merely notified by the game that your cards must be redistributed between the two hands.` },
    { "name": `The wild card, or Joker, may be used only as a single Ace; or to complete a flush, straight, or a straight flush. ` },
    { "name": `The 5-card hand must be "the highest". The player must try to create the best possible 5-card hand from his seven dealt cards. In Pai Gow Poker, the highest-ranking hand is 5 Aces (i.e. 4 Aces plus the wild card). ` },
    { "name": `The 2-card hand is referred to as "the second highest". The 2-card hand of highest rank is a pair of Aces. If the second highest hand is not composed of a pair, the value of the cards determines the hand's rank. ` },
    { "name": `When the player and the dealer compare hands that have the same rank, that hand is referred to as a "copy hand". Unlike in blackjack, where a copy hand results in a push, the dealer wins the copy hand in Pai Gow.` },
    {
        "name": <table border={"1px solid black"} >
            <thead>
                <tr><th colSpan={2} style={{ textAlign: "center" }}>Pai Gow Hand Ranking (Highest to Lowest in rank)</th></tr>
            </thead>
            <tbody>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>5 Aces</td>
                    <td style={{ paddingLeft: "10px" }}>4 Aces + the wild card</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Royal Flush</td>
                    <td style={{ paddingLeft: "10px" }}>A,K,Q,J,10 of the same suit. The highest card is the ace.</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Straight Flush</td>
                    <td style={{ paddingLeft: "10px" }}>Five cards of the same suit in the numerical order (e.g.7,8,9,10,J)</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Four of a Kind</td>
                    <td style={{ paddingLeft: "10px" }}>(e.g.A,A,A,A,X)</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Full House</td>
                    <td style={{ paddingLeft: "10px" }}>Three of a kind plus a pair (e.g.J,J,J,5,5)</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Flush</td>
                    <td style={{ paddingLeft: "10px" }}>5 cards of the same suit</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Straight</td>
                    <td style={{ paddingLeft: "10px" }}>Five of differnet cards in numerical order(e.g.A,2,3,4,5)</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Three of a kind</td>
                    <td style={{ paddingLeft: "10px" }}>(e.g.8,8,8,X,X)</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Two Pairs</td>
                    <td style={{ paddingLeft: "10px" }}>(e.g.6,6,9,9,X)</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>One Pair</td>
                    <td style={{ paddingLeft: "10px" }}>(e.g.10,10,X,X,X)</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>High Card</td>
                    <td style={{ paddingLeft: "10px" }}>If neither of the above hands can be created from your dealt cards, you will compete against the dealer's hand with your highest card.</td>
                </tr>
            </tbody>
        </table>
    },



    { "name": `The only difference between the system of ranking hands in Pai Gow Poker and in other poker games is that A-K-Q-J-10 ranks as the highest straight, A-2-3-4-5 ranks as the second highest straight, followed by K-Q-J-10-9. ` },
    { "name": `In traditional, real-life casinos, a Pai Gow player can act as the dealer. The player that acts as dealer must be able to cover all bets at the table. In the Pai Gow Poker game at this Casino, the option of becoming dealer has been excluded.` },
    {
        "name": <table border={"1px solid black"} width={"100%"} >
            <thead>
                <tr><th colSpan={2} style={{ textAlign: "center" }}>Declaring Pai Gow Winner</th></tr>
            </thead>
            <tbody>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Player</td>
                    <td style={{ paddingLeft: "10px" }}>Player's both hands must beat the Dealer's both hands.</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Push</td>
                    <td style={{ paddingLeft: "10px" }}>Player's won the first hand and lost Second hand to Dealer.</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Lost</td>
                    <td style={{ paddingLeft: "10px" }}>Player's lost the first hand and won the second hand</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: "10px" }}>Dealer</td>
                    <td style={{ paddingLeft: "10px" }}>Dealer's both hands beat player's both hands</td>
                </tr>
            </tbody>
        </table>
    },
]
const tableProps = [
    { title: "Hand Id", key: "handId", isdisplay: true },
    { title: "Dealer First Hand", key: "dealerCards", isdisplay: true, isArray: true, isShowCards: true },
    { title: "Dealer Second Hand", key: "dealerSplit", isdisplay: true, isArray: true, isShowCards: true },
    { title: "Player First Hand", key: "playerCards", isdisplay: true, isArray: true, isShowCards: true },
    { title: "Player Second Hand", key: "playerSplit", isdisplay: true, isArray: true, isShowCards: true },
    { title: "Bet", key: "betAmount", isdisplay: true },
    { title: "Win", key: "winAmount", isdisplay: true },
    { title: "Winner", key: "winner", isdisplay: true },
]


const PaiGowGame = forwardRef((props, ref) => {

    const boardRef = useRef()
    const controllerRef = useRef()

    const [orientation, setOrientation] = useState(''); // 'windows', 'portrait', 'landscape'
    const [infoText, setInfoText] = useState(''); // 'windows', 'portrait', 'landscape'
    const [betAmount, setBetAmount] = useState(0)
    const [duplicateBetAmount, setDuplicateBetAmount] = useState(0)
    const [winAmount, setWinAmount] = useState(0)
    const [isOptionsMenu, setOptionsMenu] = useState(false);
    const [selectedChip, setChipCount] = useState(0)
    const [prevBetAmount, setPrevBetAmount] = useState(null)
    const [betBtn, setBetBtn] = useState("Bet")
    const [clearBtn, setClearBtn] = useState("Clear")
    const [undoBtn, setUndoBtn] = useState("Undo")
    const [isMuted, setIsMuted] = useState(false);
    const [showPayOut, setShowPayOut] = useState(false);
    const [isIncDecChips, setIsIncDecChips] = useState(false);
    const [enterPopUp, setEnterPopUp] = useState(true);

    const showPayOutRef = useRef(showPayOut);
    const winAnimationRef = useRef();

    useEffect(() => {
        showPayOutRef.current = showPayOut; // keep ref updated
    }, [showPayOut]);

    useImperativeHandle(ref, () => ({
        updatePlayerInfo: (e) => {
            setDuplicateBetAmount(0)
        },
        paiGowAnteResponse,
        paiGowAnteSplitResult,
        updateGameState,
        setInfoText,
        updateMessage: (message = props.infoText) => {
            setInfoText(message)
        }
    }));

    useEffect(() => {
        const checkPayOut = (event) => {
            const clickedElement = event.target;
            if (clickedElement.id !== 'payout_img' && showPayOutRef.current) {
                setShowPayOut(false)
            }
        }
        console.log(props.language)
        window.addEventListener('resize', handleResize);
        window.addEventListener('click', checkPayOut);
        window.addEventListener('touchstart', checkPayOut);
        handleResize(); // initialize
        // props.assestsLoaderFunction()
        boardRef.current?.setTableImage()
        if (props?.gameState) {
            updateGameState()
        }
        return () => {
            window.removeEventListener('click', checkPayOut)
            window.removeEventListener('touchstart', checkPayOut)
            window.removeEventListener('resize', handleResize)
        };
    }, []);

    useEffect(() => {
        setDuplicateBetAmount(betAmount)
    }, [betAmount])



    const detectOrientation = () => {
        const isLandscape = window.innerWidth > window.innerHeight;
        if (isLandscape && window.innerWidth >= 1024) return 'windows';
        return isLandscape ? 'landscape' : 'portrait';
    };

    const handleResize = () => {
        setOrientation(detectOrientation());
    };

    useEffect(() => {
        // console.log(orientation);

        boardRef.current?.setTableImage()
    }, [orientation]);

    const updateGameState = () => {
        console.log("Checking game state in Pai Gow component:", props.gameState)
        if (props.gameState.oldHandId === props.gameState.handId) {
            setBetBtn("")
            setClearBtn("")
            setUndoBtn("")
            setBetAmount(props.gameState.response.betAmount)
            setDuplicateBetAmount(props.gameState.response.betAmount)
            setWinAmount(0)
            setIsIncDecChips(true)
            boardRef?.current?.setAllowAnte(false)
            setInfoText(props.language.select_second_hand)
            boardRef?.current?.setDealt(true)
            boardRef?.current?.playerAllowClick(true)
            // paiGowAnteResponse(props.gameState.response)
            boardRef.current.setAllCards(props.gameState.response.playerCards)
        } else {
            setBetBtn("Bet")
            setClearBtn("")
            setUndoBtn("")
            setIsIncDecChips(false)
            boardRef.current?.clearAllCards("")
            setBetAmount(0)
            setDuplicateBetAmount(0)
            setWinAmount(0)
            boardRef?.current?.setAllowAnte(true)
            setPrevBetAmount(props.gameState?.response?.betAmount)
            boardRef?.current?.setDealt(false)
            setInfoText(props.language.Place_antebet)
        }
    }

    const paiGowAnteResponse = (res) => {
        boardRef.current?.clearAllCards("")
        setIsIncDecChips(true)
        // console.log("dealing Cards")
        boardRef?.current?.startDealingCards({ dealerCards: res?.dealerCards, playerCards: res?.playerCards })
    }

    const checkPlayerOrDealerWin = (res) => {
        if (res.winAmount > 0) {
            setWinAmount(res.winAmount)
            winAnimationRef.current?.showWinAnimationAndMinAmount(res.winAmount)
            boardRef.current?.playWinGlowSound()
            setTimeout(() => {
                setWinAmount(0)
            }, 4000)
            setTimeout(() => {
                clearAllOnBoard()
            }, 7000)
        } else {
            setTimeout(() => {
                // boardRef.current?.playLostSound()
                clearAllOnBoard()
            }, 1500)
        }
    }

    const clearAllOnBoard = () => {
        boardRef.current?.setWinMessage("")
        boardRef.current?.setHandMessages("")
        boardRef.current?.clearAllCards("")
        getPlayerInfo()
        callGameState()
    }

    const paiGowAnteSplitResult = (res) => {
        boardRef?.current?.revealDealerCards({ dealerCards: res?.dealerCards, dealerSplit: res?.dealerSplit })
        setInfoText(props.language.wait_cards_dealt)
        setTimeout(() => {
            boardRef.current?.setWinMessage(res.message)
            boardRef.current?.setHandMessages(res)
            setTimeout(() => {
                checkPlayerOrDealerWin(res)
            }, 1500)
            setInfoText(res.message)
        }, 3300)
    }

    const callGameState = () => {
        let body = {
            sessionId: sessionStorage.getItem("sessionId"),
            CN: "GET_GAME_STATE",
            object: {
                gameId: `${props.gameId}`,
                playerId: Number(props.playerId),
            },
        }
        props.network.sendof(body);
    }

    const getPlayerInfo = () => {
        const body2 = {
            CN: "GET_PLAYER_INFO",
            object: {
                gameId: Number(props.gameId),
                playerId: Number(props.playerId),
            },
            sessionId: sessionStorage.getItem('sessionId'),
        }
        props.network.sendof(body2);
    }

    const toggleMute = () => {
        const newMuteState = !isMuted;
        setIsMuted(newMuteState);
        boardRef?.current?.toggleMute(newMuteState)
    };

    useEffect(() => {
        // console.log("betBtn", betBtn)
    }, [betBtn])


    return (
        <div className={`${orientation}Paigow`}
            id="paiGowGameBoard">
            <PaiGowGameControllers
                ref={controllerRef}
                language={props.language}
                selectedChip={selectedChip}
                setChipCount={setChipCount}
                isIncDecChips={isIncDecChips}
                playChipSound={boardRef.current?.playChipSound}
                chipsArray={props.pg_chipValues}></PaiGowGameControllers>
            <PaiGowGameBoard
                ref={boardRef}
                betBtn={betBtn}
                clearBtn={clearBtn}
                undoBtn={undoBtn}
                setBetBtn={setBetBtn}
                setClearBtn={setClearBtn}
                setIsIncDecChips={setIsIncDecChips}
                setUndoBtn={setUndoBtn}
                pg_minBet={props.pg_minBet}
                pg_maxBet={props.pg_maxBet}
                language={props.language}
                setInfoText={setInfoText}
                selectedChip={selectedChip}
                chipsArray={props.pg_chipValues}
                balance={props.balance}
                betAmount={betAmount}
                network={props.network}
                playerId={props.playerId}
                gameState={props.gameState}
                orientation={orientation}
                gameId={props.gameId}
                assestsLoaderFunction={props.assestsLoaderFunction}
                setBetAmount={setBetAmount}></PaiGowGameBoard>
            <div>
                <span id='optionMenu' onClick={() => { boardRef.current?.playMenuSound(); setOptionsMenu(true) }}><FaBars /></span>
                <div className="userInfo">
                    <img src={user_img} className="paiGow_icon" alt='User' draggable="false" />
                    <span>{props.user}</span>
                </div>
                <div className="balanceInfo">
                    <img src={balance_img} className="paiGow_icon" alt='Balance' draggable="false" />
                    <span>{Number((props.balance - duplicateBetAmount).toFixed(2))}</span>
                </div>
                <div className="betInfo">
                    <img src={betChip_img} className="paiGow_icon" alt='Bet Amount' draggable="false" />
                    <span>{Number(betAmount.toFixed(2))}</span>
                </div>
                <div className="winInfo">
                    <img src={winCup_img} className="paiGow_icon" alt='Win Amount' draggable="false" />
                    <span>{Number(winAmount.toFixed(2))}</span>
                    <></>
                </div>

                <div id="infoContainer">
                    <span id="infoPaiGow" className='infoPaiGow'>{infoText}</span>
                </div>

                <div id="playerHandDetails">
                    <div id="player_id" >P ID: {props.playerId}</div>
                    <div id="hand_id" >Hand ID: {props.gameState?.handId}</div>
                </div>

                <img id='mute' src={isMuted ? muteImg : SoundImg} height={isMuted && "70px"} onClick={toggleMute} alt='Sound' draggable="false" />
                <div id='info'>
                    <img title='PayOut' id='payout_img' src={infoImg} alt='PayOut' draggable="false" onClick={() => { setShowPayOut(prev => !prev) }} />
                    {showPayOut && <table id='payoutTable'>
                        <thead>
                            <tr>
                                <th>Player Hands Won</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Both Hands</td>
                                <td>BET X 1.95</td>
                            </tr>
                            <tr>
                                <td>Highest Hand</td>
                                <td>BET X 1</td>
                            </tr>
                        </tbody>
                    </table>}
                </div>
            </div>
            {
                isOptionsMenu && <OptionsMenu GameRules={GameRules} history={props.gameState?.history} tableProps={tableProps} minBetAmt={props.pg_minBet} maxBetAmt={props.pg_maxBet} tableclass="historyTable" headClass="" bodyClass="" openOptions={() => { setOptionsMenu(false) }} />
            }
            {/* <CoinBurst ref={winAnimationRef}></CoinBurst> */}
            {Boolean(winAmount) && <CardSparkAnimation winAmount={winAmount}></CardSparkAnimation>}
            {/* <WinAnimation showWinAnimation={Boolean(winAmount)} amount={winAmount} isbaccaratgame={true} /> */}

            {enterPopUp && <div className="iosFetchSounds" id="iospopup" onClick={(e) => setEnterPopUp(false)}>
                <div className="popupTooLong">
                    <div className="mt-2">{props.language.Wel_PG}</div>
                    {props.language?.OK_Btn}
                    <br></br>
                    <br></br>
                    <div className="fd">
                        <button className="btn_iosPopup" > OK </button>
                        <br></br>
                    </div>
                </div>
            </div>}
        </div>
    );
}); // End of forwardRef

export default (PaiGowGame);
